"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SubMenu = require("../SubMenu/SubMenu");

var _SubMenu2 = _interopRequireDefault(_SubMenu);

var _HeaderContext = require("../HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

var _profileIcon = require("./profile-icon.png");

var _profileIcon2 = _interopRequireDefault(_profileIcon);

require("./UserMenu.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var UserMenu = function UserMenu(props) {
  var avatarUrl = props.avatarUrl,
      children = props.children,
      _onClick = props.onClick,
      routes = props.routes,
      id = props.id,
      userInfo = props.userInfo;
  var selfUrl = {
    route: '/u/self',
    inApp: true
  };
  return _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
    var expandedMenu = context.expandedMenu,
        setExpandedMenu = context.setExpandedMenu;
    return _react2.default.createElement("div", {
      className: "pad-9 pos-r"
    }, _react2.default.createElement("button", {
      className: "naked-button fff-header-account-button pad-0 cur-pointer",
      onClick: function onClick() {
        return _onClick(selfUrl);
      },
      onMouseOver: function onMouseOver() {
        return setExpandedMenu(props);
      }
    }, _react2.default.createElement("img", {
      src: !!avatarUrl.length ? avatarUrl : _profileIcon2.default,
      alt: "My Account"
    })), expandedMenu && expandedMenu.id === id && _react2.default.createElement(_SubMenu2.default, {
      id: "my_account",
      right: true,
      subRoutes: routes,
      children: children,
      onRouteClick: _onClick,
      onMouseLeave: function onMouseLeave() {
        setExpandedMenu();
      },
      userInfo: userInfo
    }));
  });
};

exports.default = UserMenu;